import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download, Printer, Send } from "lucide-react";
import { downloadBlob } from "@/lib/pdfPreview";
import { PdfViewer } from "@/components/PdfViewer";

export const PdfPreviewHost = () => {
  const [doc, setDoc] = useState(null);
  const frame = useRef(null);
  useEffect(() => {
    const on = (e) => setDoc((old) => { if (old) URL.revokeObjectURL(old.url); return { ...e.detail, url: URL.createObjectURL(e.detail.blob) }; });
    window.addEventListener("pdf-preview", on);
    return () => window.removeEventListener("pdf-preview", on);
  }, []);
  const close = () => { if (doc) URL.revokeObjectURL(doc.url); setDoc(null); };
  const print = () => {
    frame.current?.remove();
    const f = document.createElement("iframe");
    f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
    f.src = doc.url;
    f.onload = () => { try { f.contentWindow.focus(); f.contentWindow.print(); } catch { window.open(doc.url, "_blank"); } };
    document.body.appendChild(f); frame.current = f;
  };
  const file = doc && new File([doc.blob], doc.filename, { type: "application/pdf" });
  const canShare = !!(file && navigator.canShare && navigator.canShare({ files: [file] }));
  const send = async () => {
    if (canShare) { try { await navigator.share({ files: [file], title: doc.filename }); } catch (e) { if (e?.name !== "AbortError") toast.error("Invio non riuscito"); } return; }
    downloadBlob(doc.blob, doc.filename);
    window.location.href = `mailto:?subject=${encodeURIComponent(doc.filename)}&body=${encodeURIComponent("In allegato il documento " + doc.filename + " (allegalo dalla cartella Download).")}`;
  };
  return <Dialog open={!!doc} onOpenChange={(o) => !o && close()}>
    <DialogContent className="max-w-5xl w-[96vw] h-[90vh] flex flex-col gap-3" data-testid="pdf-preview-dialog">
      <DialogHeader><DialogTitle className="truncate pr-8" data-testid="pdf-preview-title">{doc?.filename}</DialogTitle></DialogHeader>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white" onClick={() => downloadBlob(doc.blob, doc.filename)} data-testid="pdf-preview-download"><Download className="w-4 h-4 mr-1.5" />Scarica</Button>
        <Button size="sm" variant="outline" onClick={print} data-testid="pdf-preview-print"><Printer className="w-4 h-4 mr-1.5" />Stampa</Button>
        <Button size="sm" variant="outline" onClick={send} title={canShare ? "Condividi con email, WhatsApp e altre app" : "Scarica il PDF e apre una nuova email"} data-testid="pdf-preview-send"><Send className="w-4 h-4 mr-1.5" />Invia</Button>
      </div>
      {doc && <PdfViewer blob={doc.blob} className="flex-1 w-full" testid="pdf-preview-frame" />}
    </DialogContent>
  </Dialog>;
};
